exports.APIS = {
  Auth: {
    CreateCustomerSignup: "/customer-signup",
    sendLoginOtp: "/send_otp",
    LoginverifyOtp: "/verify_otp",
    GETProfile: "/user/profile",
    Update_Profile: "/user/profile",

    GETLevel: "/master/levels",
    GETLevelDeatils: "/master/levelDetails",
    GetUserLevelDetails: "/master/LevelRank",
    GetUserNotification: "/getnotification",
    GetUserTransaction: "/master/wallet",
    SEND_OTP: "/send-otp",
    VERIFY_OTP: "/verify-otp",
    Sign_Up: "/signup",
    Customer_Login: "/login",
    forgotPassword: "/updatePassword",
    getUserWalletHistory: "/wallet_history",
    getUserIncomeDetails: "/userIncomeDetails",
  }, // mine
  UserGet: "/common/auth/user-info",
  ChangePassword: "/common/auth/change-password",

  ContactUs: {
    Contact_Us: "/master/contactus",
  },
  Product: {
    Product_Detail: "/productdetails",
    addAddress: "/user/userstoreAddress",
    getAllAddress: "/user/getaddress",
    GetSinglelAddress: "/user/getaddress",
    postOrder: "/place-order",
    getOrder: "/getOrder",
    getAllOrder: "/user/orderHistory",
  },

  Kyc: {
    Kyc_Step1: "/user/kycidentifyverification",
    CreatePersonalDetail_Step2: "/user/personalDetails",
    CreateBankDetail_Step3: "/user/BankDetail",
    GetStepsDetail: "/user/KycReviewDetails",
  },

  Commons: {
    AllCountry: "/master/countries",
    AllState: "/master/states",
    AllCities: "/master/cities",
    AllBanners: "/master/banners",
    AllReviews: "/master/reviews",
    AllAboutUs: "/master/aboutus",
    AllAdvantages: "/master/advantages",
    AllPrivacyPolicyContent: "/master/privacypolicycontents",
    AllPrivacyPolicy: "/master/privacypolicies",
    AllTermconditionContent: "/master/termsconditioncontents",
    AllTermcondition: "/master/termsconditions",
    AllShareholder: "/master/shareholders",
    AllStepToJoin: "/master/steptojoins",
    AllCity: "/master/cities",
    AllOrderStatus: "/master/orderStatus",

    AllCartegory: "/servicecategory",
    AllProfession: "/get-profession",
    AllAppSetup: "/master/appsetup",
    AllCategories: "/servicecategory",
    AllProfessions: "/get-profession",
    AllPurchaseDate: "/get-purchase-date",
    AllDocumentType: "/master/documents",
  },
};
